import React, { useEffect, useState, useRef } from 'react';
import { Map, BookOpen, Ticket, Compass } from 'lucide-react';
import { motion } from 'framer-motion';
type NavItem = 'map' | 'regulations' | 'permits' | 'recommendations';
interface BottomNavProps {
  activeTab: NavItem;
  onTabChange: (tab: NavItem) => void;
}
export function BottomNav({
  activeTab,
  onTabChange
}: BottomNavProps) {
  const navItems = [{
    id: 'map',
    icon: Map,
    label: 'Explore'
  }, {
    id: 'recommendations',
    icon: Compass,
    label: 'For You'
  }, {
    id: 'permits',
    icon: Ticket,
    label: 'Permits'
  }, {
    id: 'regulations',
    icon: BookOpen,
    label: 'Rules'
  }] as const;
  const containerRef = useRef<HTMLDivElement>(null);
  const [indicatorStyle, setIndicatorStyle] = useState({
    left: 0,
    width: 0
  });
  useEffect(() => {
    const activeIndex = navItems.findIndex(item => item.id === activeTab);
    const container = containerRef.current;
    if (container) {
      const buttons = container.querySelectorAll('button');
      const activeButton = buttons[activeIndex];
      if (activeButton) {
        const containerRect = container.getBoundingClientRect();
        const buttonRect = activeButton.getBoundingClientRect();
        setIndicatorStyle({
          left: buttonRect.left - containerRect.left,
          width: buttonRect.width
        });
      }
    }
  }, [activeTab]);
  return <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50" data-id="element-126">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-[var(--bg-card)]/90 backdrop-blur-xl border-t border-[var(--border)]" data-id="element-127" />

      {/* Content */}
      <div ref={containerRef} className="relative flex items-center h-14 px-2" data-id="element-128">
        {/* Sliding indicator */}
        <motion.div className="absolute top-1.5 h-11 bg-[var(--accent)] rounded-xl" animate={{
        left: indicatorStyle.left,
        width: indicatorStyle.width
      }} transition={{
        type: 'spring',
        stiffness: 500,
        damping: 35
      }} data-id="element-129" />

        {navItems.map(item => {
        const Icon = item.icon;
        const isActive = activeTab === item.id;
        return <button key={item.id} onClick={() => onTabChange(item.id)} className="relative flex-1 flex flex-col items-center justify-center h-full py-1.5 z-10" data-id="element-130">
              <Icon className={`w-5 h-5 transition-colors duration-200 ${isActive ? 'text-white' : 'text-[var(--text-muted)]'}`} strokeWidth={2} data-id="element-131" />
              <span className={`text-[10px] mt-0.5 font-medium transition-colors duration-200 ${isActive ? 'text-white' : 'text-[var(--text-muted)]'}`} data-id="element-132">
                {item.label}
              </span>
            </button>;
      })}
      </div>

      {/* Safe area padding */}
      <div className="h-safe bg-[var(--bg-card)]/90 backdrop-blur-xl" data-id="element-133" />
    </nav>;
}